import React, { useRef, useState } from 'react';
import CalendarSelector from './CalendarSelector';
import CalendarPopover from './CalendarPopover';
import './SwitchTargets.css';

const SwitchTargets = ({ event, socket }) => {
    const targets = (event?.targets || "")
        .split(',')
        .map(target => target.trim())
        .filter(target => target !== '')

  const [selectedTargets, setSelectedTargets] = useState(targets);
  const [showForAllFutureEvents, setShowForAllFutureEvents] = useState(false);
  const editorRef = useRef(null);

  const changeTarget = (newTarget) => {
    setSelectedTargets(prevTargets => {
        if (newTarget === '') {
            setShowForAllFutureEvents(false)
            socket.emit('.change_event_targets', event.hash, '');
            return []
        } else if (prevTargets.includes(newTarget)) {
            setShowForAllFutureEvents(false)
            const newTargets = prevTargets.filter(target => target !== newTarget)
            socket.emit('.change_event_targets', event.hash, newTargets.join(','));
            return newTargets
        } else {
            if (newTarget === 'tècnica') {
              setShowForAllFutureEvents(true)
            } else {
              setShowForAllFutureEvents(false)
            }

            let newTargets = [...prevTargets, newTarget]
            
            // If caps de tècnica is selected, remove tècnica
            if (newTarget === 'caps tècnica') {
                newTargets = newTargets.filter(target => target !== 'tècnica')
            }
            // If tècnica is selected, remove caps de tècnica
            if (newTarget === 'tècnica') {
                newTargets = newTargets.filter(target => target !== 'caps tècnica')
            }
            // If caps de junta is selected, remove junta
            if (newTarget === 'caps junta') {
                newTargets = newTargets.filter(target => target !== 'junta')
            }
            // If junta is selected, remove caps de junta
            if (newTarget === 'junta') {
                newTargets = newTargets.filter(target => target !== 'caps junta')
            }

            socket.emit('.change_event_targets', event.hash, newTargets.join(','));
            return newTargets
        }
    });
  }

  const options = [
    { value: '', label: 'Tots' },

    { value: 'tècnica', label: 'Tècnica' },
    { value: 'caps tècnica', label: 'Caps de tècnica' },

    { value: 'junta', label: 'Junta' },
    { value: 'caps junta', label: 'Caps de junta' },
  ];

  return (
    <div className="calendar-events-targets-editor" ref={editorRef}>
      <CalendarSelector
        label="Visibilitat"
        options={options}
        selectedValues={selectedTargets.length === 0 ? [''] : selectedTargets}
        onSelect={changeTarget}
        multiple
        closeOnSelect
        emptyLabel="Tots"
      />

      {showForAllFutureEvents ? (
        <CalendarPopover
          anchorRef={editorRef}
          onClose={() => setShowForAllFutureEvents(false)}
          width={300}
          initialFocus="button:last-child"
          className="calendar-events-targets-confirm"
          role="dialog"
          aria-label="Confirmar visibilitat per tècnica"
        >
          <h4>Vols posar privats per tècnica aquest esdeveniment i tots els següents?</h4>
          <div className="calendar-events-targets-confirm-actions">
            <button
              type="button"
              onClick={() => {
                socket.emit('.add_target_to_all_future_events', event.hash, 'tècnica');
                setShowForAllFutureEvents(false);
              }}
            >
              Sí
            </button>
            <button type="button" onClick={() => setShowForAllFutureEvents(false)}>No</button>
          </div>
        </CalendarPopover>
      ) : null}
    </div>
  );
};

export default SwitchTargets;
